require('es6-promise').polyfill();
import axios from 'axios';
import config from '../constants/Config';

const isDummy = (STATE_INITIALS === 'demo');
const baseURL = (isDummy) ? '' : 'backend';
const server = axios.create({
  baseURL
});

// require the dummy server if needed
const dummyServer = (isDummy) ? require('./DummyTurnService') : null;

const MAX_POST_RETRIES = 50;

/////////////////////////////////////////////////////////////////////////
// CONSTRUCTOR //////////////////////////////////////////////////////////
/////////////////////////////////////////////////////////////////////////
const GameTurnService = {

  onSignalStartGameDataReceived: new Phaser.Signal(),
  onSignalEndGameReceived: new Phaser.Signal(),
  onSignalLeaderDataReceived: new Phaser.Signal(),
  onSignalInitialsSubmitted: new Phaser.Signal(),
  onSignalRankDataReceived: new Phaser.Signal(),


  // keep retrying POST requests that fail due to network problems
  retries: 0,

  // init
  init() {
    return this;
  },

  // start game - retrieve basic game info
  startGame() {

    console.log('version', config.version, 'is dummy? ', isDummy);

    if (dummyServer) {
      return dummyServer.startGame_dumb(true);
    }

    return this.get('/simple/gamestart.php', {params: {version: config.version}}, this.onSignalStartGameDataReceived);
  },

  // turn ended - send result and retrieve new balls and data
  endGame(gamesPlayed_id, finalScore) {

    const postData = {
      gamesPlayed_id,
      finalScore
    };

    if (dummyServer) {
      return dummyServer.endGame_dumb(true);
    }

    return this.post('/simple/gamecompleted.php', postData, this.onSignalEndGameReceived);
  },

  fetchRankData(score) {

    if (dummyServer) {
      return dummyServer.fetchRankData_dumb(...arguments);
    }

    const params = {
      params: {
        score
      }
    };
    return this.get('/rank.php', params, this.onSignalRankDataReceived);
  },

  fetchLeaderData(numLeaders) {

    if (dummyServer) {
      return dummyServer.fetchLeaderData_dumb(...arguments);
    }

    const params = {
      params: {
        limit: numLeaders
      }
    };
    return this.get('/getleaders.php', params, this.onSignalLeaderDataReceived);
  },

  submitPlayerInitials(gamesPlayed_id, initials) {

    if (dummyServer) {
      return dummyServer.submitPlayerInitials_dumb(...arguments);
    }

    const postData = {
      gamesPlayed_id,
      initials
    };
    return this.post('/simple/submitplayerinitials.php', postData, this.onSignalInitialsSubmitted);
  },

  post(url, postData, signal) {

    const cb = (signal) ? signal.dispatch.bind(signal) : () => {};
    server.post(url, postData)
      .then(response => {
        //console.log(url, response);
        if (response.data.success === 1) {
          cb(response.data.data);
        }
        else {
          this.recordError(url, response.data.error);
          cb(response.data.data, response.data.error);
        }
        if (this.retries > 1) {
          const recoveredMsg = 'recovered after ' + this.retries + ' retries';
          this.recordError(url, recoveredMsg);
          console.log(recoveredMsg);
        }
        this.retries = 0;
      })
      .catch(error => {
        // FAILED TO LOAD RESOURCE: THE NETWORK CONNECTION WAS LOST (turncompleted.php)
        // WE NEED TO RETRY THE REQUEST A FEW TIMES!!!
        if (++this.retries < MAX_POST_RETRIES) {
          setTimeout(() => {
            this.post(url, postData, signal);
          }, 30);
        }
        else {
          this.recordError(url, 'max retries');
          console.log(error, this.retries);
          cb({}, error);
        }

      });

    return signal;
  },

  get(url, params, signal) {

    const cb = signal.dispatch.bind(signal);
    server.get(url, params)
      .then(response => {
        //console.log(url, response);
        if (response.data.success === 1) {
          cb(response.data.data);
        }
        else {
          this.recordError(url, response.data.error);
          cb(response.data.data, response.data.error);
        }
      })
      .catch(error => {
        this.recordError(url, 'unknown');
        console.log(error);
        cb({}, error);
      });

    return signal;
  },

  recordError(url, message='???', gameRecord_id=0) {

    console.log('recordError: ', url, message);
    if (dummyServer) {
      return;
    }

    server.post('/error.php', {url, message, gameRecord_id})
      .then(response => {
        if (!response.data.success) {
          console.log('FAIL:1', url, response.data.error);
        }
      })
      .catch(error => {
        console.log('FAIL:2', error);
      });

  }



};

export default GameTurnService;



// WEBPACK FOOTER //
// ./app/src/server/GameTurnService.js